export default "__VITE_ASSET__DYzioCcf__"